import React,{Component} from 'react'
import type from './decorator'

class StaticLookup extends Component{
    render(){
        const {onChange,validationState,errorsFor,config} = this.props
            return null
    }
}

export default type({
    label:'Static',
    type:'static',
    properties:[],
    config:{},
    validations:{}
})(StaticLookup)